import { dashboardMapEventsService } from './dashboardMap.subject';

export type MapModeId =
	| 'default'
	| 'digital-twin'
	| 'dma'
	| 'health'
	| 'inflow'
	| 'mms'
	| 'simulations'
	| 'heatmap'
	| 'past-overflow'
	| 'sensor-maintenance'
	| 'alerts'
	| 'sewer-analysis';

export type DashboardMapEvent =
	| { type: 'changeAnimation'; data: boolean }
	| { type: 'setMode'; data: MapModeId }
	| { type: 'resetDma' }
	| { type: 'cleanRainfallLayer' }
	| { type: 'drawRainfallLayer'; data: { futureRainfall: boolean } }
	| { type: 'futureRainfallToggleChanged'; data: { futureRainfall: boolean } }
	| { type: 'closePopup' }
	| { type: 'datesApplied' }
	| { type: 'zoomToAsset'; data?: { infrastructureId?: number | string } };

export function publishDashboardMapEvent(event: DashboardMapEvent): void {
	dashboardMapEventsService.setSubject(event);
}
